import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type {
  IAddAddressApiPayload,
  TAddAddressApiResponse,
} from '../types/UpdateOffice.api';

export const addAddress = async (
  payload: IAddAddressApiPayload,
): Promise<TAddAddressApiResponse> => {
  const headers = await getAuthHeaders();
  const { data } = await tempMeeApi.post<TAddAddressApiResponse>(
    '/user/address',
    payload,
    { headers },
  );
  return data;
};
